<template>
  <div class="payment__instrument">
    <div class="paysafe-container payments_form">
      <div class="label">{{ $t('Transaction.Paysafe') }}</div>
      <p v-html="$t('Transaction.Paysafe.Desc')" class="desc"></p>
      <div class="mthds-cont">
        <div class="mthds-img"><img class="psimg all" :src="mediaServer('/static/brand-img/' + brandKey + '/paysafe-instruments.png')" alt="paysafe-instruments"/></div>
      </div>
      <v-form ref="form" id="form" v-model="valid" lazy-validation @submit.prevent="submit">
        <div>
          <v-text-field
            inputmode="decimal"
            v-model="formData.amount"
            :label="$t('Transaction.Amount')"
            :prefix="currencySymbol"
            required
            :disabled="isProcessing"
            :rules="formInputRules"
            class="my-3 input-amount"
          >
          </v-text-field>
          <div class="content">
            <v-btn v-if="depositType" class="transaction" :disabled="isProcessing || !valid || !customerCanDeposit" color="success" @click="startTransaction('R')">{{ $t('Transaction.Deposit') }}</v-btn>
            <v-btn v-if="withdrawType" class="transaction" :disabled="isProcessing || !valid || !customerCanWithdraw" color="success" @click="startTransaction('P')">{{ $t('Transaction.Withdrawal') }}</v-btn>
          </div>
        </div>
      </v-form>
      <div class="go-back">
        <span class="go-back-content" @click="goToHomepage()"><v-icon>navigate_before</v-icon><span>{{back}}</span></span>
      </div>
    </div>
    <PaysafeProcessingDialog
      v-model="dialog"
      :isDialogPersistent="true"
      :isProcessing="isProcessing"
      :isSuccess="!transactionError"
      :hideResult="paymentHandleNotCreated || paymentHandleCreated"
      :processingTitle="$t('Transaction.Dialog.Processing.Title')"
      :processingText="$t('Transaction.Dialog.Processing.Text')"
      :successTitle="paysafeCashSuccessTitle || $t('Transaction.Dialog.Success.Title')"
      :successText="paysafeCashSuccessText || $t('Transaction.Dialog.Success.Text')"
      :errorTitle="$t('Transaction.Dialog.Error.Title')"
      :closeBtnText="$t('ProcessingDialog.CloseButtonText')"
    >
      <div slot="text-error">
        <p>{{ transactionError }}</p>
        <p v-if="errorReference">{{ $t('Account.TransactionHistory.History.Reference') }}: {{ errorReference }}</p>
        <p v-if="brandKey ==='sb'" v-html="customerServiceMessage"></p>
      </div>
    </PaysafeProcessingDialog>
  </div>
</template>
<script>
import store from '@/store'
import config from '@/config'
import PaysafeProcessingDialog from '@/components/payments/PaysafeProcessingDialog'
import Url from '@/components/mixins/Url'
let viewModel = null
export default {
  components: {
    PaysafeProcessingDialog
  },
  mixins: [Url],
  data: () => ({
    formData: {
      amount: ''
    },
    formRules: {
      amount: {
        required: (value) => !!value || viewModel.$t('Transaction.Amount.IsRequired'),
        number: (value) => (value > 0) || viewModel.$t('Transaction.Amount.Number'),
        max2Decimals: v => /^\s*(?=.*[1-9])\d*(?:\.\d{1,2})?\s*$/g.test(v) || viewModel.$t('Transaction.Amount.Deposit.Max2Decimals'),
        maxDepositAmount (value) {
          const max = +viewModel.maxDepositAmount
          if (!max || value <= max) {
            return true
          }
          return viewModel.currencySymbol ? viewModel.$t('Payments.maxDepositAmount.currency', { max }) : viewModel.$t('Payments.maxDepositAmount', { max })
        },
        minDepositAmount (value) {
          const min = +viewModel.minDepositAmount
          if (!min || value >= min) {
            return true
          }
          return viewModel.currencySymbol ? viewModel.$t('Payments.minDepositAmount.currency', { min }) : viewModel.$t('Payments.minDepositAmount', { min })
        },
        maxWithdrawalAmount (value) {
          const max = +viewModel.maxWithdrawalAmount
          if (!max || value <= max) {
            return true
          }
          return viewModel.currencySymbol ? viewModel.$t('Payments.maxWithdrawalAmount.currency', { max }) : viewModel.$t('Payments.maxWithdrawalAmount', { max })
        },
        minWithdrawalAmount (value) {
          const min = +viewModel.minWithdrawalAmount
          if (!min || value >= min) {
            return true
          }
          return viewModel.currencySymbol ? viewModel.$t('Payments.minWithdrawalAmount.currency', { min }) : viewModel.$t('Payments.minWithdrawalAmount', { min })
        }
      }
    },
    valid: true,
    dialog: false
  }),
  computed: {
    depositInstrument: () => store.getters['paysafe/depositInstrument'],
    withdrawalInstrument: () => store.getters['paysafe/withdrawalInstrument'],
    pollingTransaction: () => store.getters['paysafe/pollingTransaction'],
    isTransactionProcessingInvoked () {
      return store.getters['paysafe/getIsTransactionProcessingInvoked']
    },
    isProcessing () {
      return this.isTransactionProcessingInvoked || this.pollingTransaction || this.processingPaysafeTransaction
    },
    brandKey: () => window.ctsautoconf.BRAND,
    transactionError: {
      get: () => store.getters['paysafe/transactionError'],
      set: (value) => void (store.commit('paysafe/transactionError', value))
    },
    SDKisDisplayed: () => store.getters['paysafe/SDKisDisplayed'],
    processingPaysafeTransaction: () => store.getters['paysafe/processingPaysafeTransaction'],
    raiseDialog: () => store.getters['paysafe/raiseDialog'],
    hideDialog: () => store.getters['paysafe/hideDialog'],
    paysafeCashSuccessText: () => store.getters['paysafe/paysafeCashSuccessText'],
    paysafeCashSuccessTitle: () => store.getters['paysafe/paysafeCashSuccessTitle'],
    paysafePaymentStage: () => store.getters['paysafe/paysafePaymentStage'],
    paymentHandleNotCreated () {
      return this.paysafePaymentStage && this.paysafePaymentStage === 'PAYMENT_HANDLE_NOT_CREATED'
    },
    paymentHandleCreated () {
      return this.paysafePaymentStage && this.paysafePaymentStage === 'PAYMENT_HANDLE_CREATED'
    },
    accountNotVerified: () => store.getters['paysafe/accountNotVerified'],
    customerServiceMessage () {
      return this.accountNotVerified ? this.$t('Transaction.Dialog.Error.ContactSupport') : this.$t('Transaction.Dialog.Error.Text.ContactSupport')
    },
    currencySymbol () {
      return config.app.CURRENCY
    },
    back () {
      if (this.paysafeOnlyDeposit && this.depositType) return this.$t('Header.navigationBack')
      if (this.paysafeOnlyWithdrawal && this.withdrawType) return this.$t('Header.navigationBack')
      return this.$t('Transaction.GoBack')
    },
    paysafeOnlyDeposit: () => store.getters['payments/paysafeOnlyDeposit'],
    paysafeOnlyWithdrawal: () => store.getters['payments/paysafeOnlyWithdrawal'],
    transactionType: () => store.getters['payments/transactionType'],
    depositType () {
      return this.transactionType && this.transactionType === 'deposit'
    },
    withdrawType () {
      return this.transactionType && this.transactionType === 'withdrawal'
    },
    customerContext: () => store.getters['getCustomerContext'],
    customerCanDeposit () {
      return this.customerContext && this.customerContext.ActionDeposit
    },
    customerCanWithdraw () {
      return this.customerContext && this.customerContext.ActionWithdraw
    },
    maxDepositAmount () {
      return store.getters['paysafe/maxDepositAmount']
    },
    minDepositAmount () {
      return store.getters['paysafe/minDepositAmount']
    },
    maxWithdrawalAmount () {
      return store.getters['paysafe/maxWithdrawalAmount']
    },
    minWithdrawalAmount () {
      return store.getters['paysafe/minWithdrawalAmount']
    },
    formInputRules () {
      let rules = [this.formRules.amount.required, this.formRules.amount.number, this.formRules.amount.max2Decimals]
      if (this.depositType) {
        rules = [...rules, this.formRules.amount.maxDepositAmount, this.formRules.amount.minDepositAmount]
      }
      if (this.withdrawType) {
        rules = [...rules, this.formRules.amount.maxWithdrawalAmount, this.formRules.amount.minWithdrawalAmount]
      }
      return rules
    },
    getShowProcessingDialog () {
      return store.getters['paysafe/getShowProcessingDialog']
    },
    errorReference: {
      get () {
        return store.getters['paysafe/getErrorReference']
      },
      set (value) {
        store.commit('paysafe/setErrorReference', value)
      }
    }
  },
  methods: {
    async startTransaction (type) {
      if (this.$refs.form.validate()) {
        try {
          this.transactionError = null
          this.errorReference = ''
          store.commit('paysafe/isTransactionProcessingInvoked', true)
          await store.dispatch('paysafe/startTransaction', {'amount': this.formData.amount, 'type': type})
          this.reset()
        } catch (err) {
          console.log(err)
        } finally {
          store.commit('paysafe/isTransactionProcessingInvoked', false)
        }
      }
    },
    reset () {
      this.$refs.form.reset()
    },
    goToHomepage () {
      if (this.paysafeOnlyDeposit && this.depositType) return this.$router.push({ name: 'sports' })
      if (this.paysafeOnlyWithdrawal && this.withdrawType) return this.$router.push({ name: 'sports' })
      else this.$router.push({name: 'wallet-page'})
    }
  },
  created () {
    viewModel = this
  },
  watch: {
    transactionError (newVal) {
      this.transactionError = newVal
      if (newVal && newVal !== 'authOperationCancelled') {
        this.dialog = true
      }
    },
    hideDialog () {
      this.dialog = false
    },
    raiseDialog () {
      this.dialog = true
    },
    getShowProcessingDialog (newVal) {
      if (newVal) {
        this.dialog = true
      }
    }
  }
}
</script>
<style lang="stylus" scoped>
@import "~@/css/config"
.paysafe-container
  padding 20px
  .paysafe-img
    margin: auto
    text-align center
    max-height 55px
    padding 0 0 10px 0
    display block
  .mthds
    text-align center
    font-weight bold
    margin-bottom -12px
  .mthds-cont
    display flex
    flex-direction column
    @media mobile-big-and-below
      margin-top -6px
    &.cards
      justify-content center
      @media mobile-big-and-below
        margin-top 0
      .cards-inner
        display flex
        justify-content center
        // max-width 40%
        margin 0
        border-radius 3px
        .mthds-img
          margin 0 5px
          border-radius 3px
          margin 2px
          max-width 50px
          @media mobile-big-and-below
            margin-bottom 4px
          .psimg
            max-height 100px
            @media mobile-big-and-below
              max-width 100%
              height 40px
            &.mastercard
              @media mobile-big-and-below
                height 40px
            &.amex
              max-height 80px
              padding 0 6px
              @media mobile-big-and-below
                height 40px
    .mthds-img
      flex 1
      margin 10px
      display flex
      align-items center
      justify-content center
      background #fff
      @media mobile-big-and-below
        justify-content center
        margin 15px 0 0
      .psimg
        max-width 100%
        max-height 28px
        &.all
          max-height initial
          @media mobile-big-and-below
            max-height initial
            height auto
            width auto
            max-width initial
        @media mobile-big-and-below
          height 25px
          max-width 50%
          &.pscash,
          &.pscard
            height 20px
  .content
    display flex
    justify-content center
    background transparent
    .transaction
      flex 1
      height 60px
      margin 5px
      max-width 200px
      font-size 15px
      display flex
      >>> div
        flex 1
        white-space normal
        @media screen and (max-width: 360px)
          font-size 11px
        @media screen and (max-width: 390px)
          font-size 13px
</style>



// WEBPACK FOOTER //
// src/components/payments/Paysafe.vue